import SwitchField from '@/components/form/SwitchField/switch-field.example';

export default SwitchField;
